export default __webpack_public_path__ + "static/media/black_rook.48ba3a7c.png";